import { render, staticRenderFns } from "./SetRequestStatusView.vue?vue&type=template&id=a234aa46&scoped=true&"
import script from "./SetRequestStatusView.vue?vue&type=script&lang=js&"
export * from "./SetRequestStatusView.vue?vue&type=script&lang=js&"
import style0 from "./SetRequestStatusView.vue?vue&type=style&index=0&id=a234aa46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a234aa46",
  null
  
)

export default component.exports